import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

import { CustomButton } from '../../../../common/components';
import InitialBalanceDialog from './InitialBalanceDialog';
import InitialBalancesTable from './InitialBalancesTable';

const InitialBalancesTab = ({
  isAdmin,
  groups,
  initialBalanceRows,
  initialBalanceDialogOpen,
  initialBalanceForm,
  setInitialBalanceForm,
  isLoading,
  pagination,
  saveLoading,
  deleteLoading,
  onOpenDialog,
  onCloseDialog,
  onSave,
  onEdit,
  onDelete,
}) => (
  <Stack spacing={3}>
    <Paper
      elevation={0}
      sx={{ p: 2.5, border: '1px solid', borderColor: 'divider' }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', md: 'center' }}
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography variant="h6">Saldos Iniciales</Typography>
          <Typography variant="body2" color="text.secondary">
            Configuracion persistente por grupo, anio y tipo de fondo.
          </Typography>
        </Box>
        <Chip
          label={pagination?.totalCount ? `${pagination.totalCount} registro(s)` : 'Sin registros'}
          color={pagination?.totalCount ? 'primary' : 'default'}
          variant="outlined"
        />
        <CustomButton
          variant={isAdmin ? 'base' : 'outlined'}
          buttonIcon={Add}
          onClick={onOpenDialog}
          disabled={!isAdmin}
        >
          Agregar saldo inicial
        </CustomButton>
      </Stack>

      <InitialBalancesTable
        rows={initialBalanceRows}
        isLoading={isLoading}
        pagination={pagination}
        isAdmin={isAdmin}
        onEdit={onEdit}
        onDelete={onDelete}
      />

      <InitialBalanceDialog
        open={initialBalanceDialogOpen}
        onClose={onCloseDialog}
        form={initialBalanceForm}
        setForm={setInitialBalanceForm}
        groups={groups}
        isLoading={saveLoading || deleteLoading}
        onSave={onSave}
      />
    </Paper>
  </Stack>
);

export default InitialBalancesTab;
